export enum GroupByDate {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export const GROUP_BY_OPTIONS = [
  {
    label: 'Day',
    value: GroupByDate.DAY,
  },
  {
    label: 'Week',
    value: GroupByDate.WEEK,
  },
  {
    label: 'Month',
    value: GroupByDate.MONTH,
  },
  {
    label: 'Year',
    value: GroupByDate.YEAR,
  },
];

export enum MgaRealMoneyBalanceListFilterFields {
  GROUP_BY_DATE = 'groupByDate',
  DATE_FROM = 'dateFrom',
  DATE_TO = 'dateTo',
  EXCHANGE_RATE_DATE = 'exchangeRateDate',
  PLAYER_ID = 'playerId',
}

export const DEFAULT_FILTER_FORM_DATA: MgaRealMoneyBalanceListFilter = {
  [MgaRealMoneyBalanceListFilterFields.GROUP_BY_DATE]: GroupByDate.MONTH,
} as const;

export type MgaRealMoneyBalanceListFilter = {
  [MgaRealMoneyBalanceListFilterFields.GROUP_BY_DATE]: GroupByDate;
  [MgaRealMoneyBalanceListFilterFields.DATE_FROM]?: string;
  [MgaRealMoneyBalanceListFilterFields.DATE_TO]?: string;
  [MgaRealMoneyBalanceListFilterFields.EXCHANGE_RATE_DATE]?: string;
  [MgaRealMoneyBalanceListFilterFields.PLAYER_ID]?: string;
}
